var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 166,
    height: 94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.02.332c-1.253.006-2.45.1-3.504.292C8.413 1.16 7.85 2.282 7.85 4.35v2.732h7.333v.91H5.097c-2.13 0-3.997 1.252-4.58 3.634C.178 13 .002 14.112 0 15.243v.038c.002 1.105.17 2.23.516 3.63.52 2.122 1.766 3.634 3.897 3.634h2.52V19.27c0-2.366 2.094-4.453 4.58-4.453h7.324c2.04 0 3.666-1.64 3.666-3.643V4.35c0-1.942-1.676-3.402-3.666-3.726a23.33 23.33 0 0 0-3.707-.292h-.114M9.678 3.9c0-.756.616-1.37 1.376-1.37s1.376.614 1.376 1.37a1.37 1.37 0 0 1-1.376 1.362c-.76 0-1.376-.61-1.376-1.362",
    id: "A"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-3.31285753%",
    y1: "5.03198351%",
    x2: "71.2066331%",
    y2: "67.5007303%",
    id: "B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#599ed4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2f6997",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.578.326V3.51c0 2.468-2.14 4.545-4.58 4.545H3.672c-2.006 0-3.666 1.68-3.666 3.643v6.826c0 1.942 1.728 3.085 3.666 3.642 2.32.667 4.547.788 7.324 0 1.846-.522 3.666-1.574 3.666-3.642V15.8H7.34v-.9h10.99c2.13 0 2.925-1.453 3.666-3.634.766-2.245.733-4.405 0-7.285C21.47 1.886 20.464.326 18.33.326h-2.752zm-5.495 18.647a1.37 1.37 0 0 1 1.376-1.362c.76 0 1.376.61 1.376 1.362s-.616 1.37-1.376 1.37-1.376-.615-1.376-1.37z",
    id: "C"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.0076447%",
    y1: "71.4054555%",
    x2: "38.4521166%",
    y2: "34.5930631%",
    id: "D"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd43b",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe872",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M.112.217H5.73v2.93H.112z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 31)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.76 16.18c0 1.978-.474 3.62-1.428 4.925-1.064 1.478-2.538 2.24-4.423 2.28-1.42.044-2.884-.4-4.4-1.303v8.446l-2.436-.85V10.93c.4-.48.914-.9 1.538-1.24 1.45-.826 3.212-1.25 5.286-1.272l.035.034c1.895-.024 3.356.737 4.382 2.28.957 1.415 1.437 3.228 1.437 5.446m-2.802-.162c0-3.893-1.135-5.892-3.406-6-.904-.042-1.786.1-2.644.425-.685.24-1.146.477-1.4.717v9.292c1.453.9 2.743 1.305 3.868 1.24 2.38-.154 3.572-2.043 3.572-5.673m17.7 5.705c0 2.653-.272 4.5-.816 5.5s-1.586 1.837-3.12 2.444c-1.245.48-2.6.74-4.036.784l-.403-1.5c1.47-.195 2.503-.4 3.103-.587 1.18-.4 2-1 2.436-1.793.357-.654.533-1.902.533-3.75v-.62a12.76 12.76 0 0 1-5.238 1.108c-1.2 0-2.258-.368-3.17-1.108-1.024-.805-1.535-1.827-1.535-3.064v-9.91l2.436-.816v9.978c0 1.066.352 1.887 1.056 2.462s1.615.852 2.732.83 2.314-.446 3.585-1.272V8.78h2.436v12.943zm9.512 1.532l-.803.034c-1.378 0-2.452-.32-3.22-.964s-1.148-1.532-1.148-2.666v-9.38h-1.67V8.78h1.67V4.8l2.434-.847V8.78h2.737v1.498h-2.737v9.316c0 .894.245 1.527.736 1.897.42.305 1.1.48 2.002.524v1.24zm14.752-.194h-2.436v-9.193c0-.935-.224-1.74-.67-2.413a2.45 2.45 0 0 0-2.146-1.14c-1.117 0-2.514.576-4.2 1.727v11.02h-2.436V1.084l2.436-.75v10c1.568-1.11 3.268-1.664 5.115-1.664 1.3 0 2.335.425 3.135 1.272s1.202 1.902 1.202 3.163v9.944zm15.618-7.402c0 2.13-.557 3.9-1.67 5.316-1.223 1.585-2.913 2.38-5.07 2.38-2.138 0-3.804-.795-5.006-2.38-1.1-1.415-1.634-3.187-1.634-5.316 0-2 .6-3.685 1.767-5.055C96.164 9.15 97.8 8.42 99.824 8.42s3.67.73 4.94 2.183c1.178 1.37 1.767 3.054 1.767 5.055m-2.668-.016c0-1.496-.3-2.73-.87-3.708-.688-1.2-1.756-1.82-3.202-1.884-2.67.15-4.004 2.022-4.004 5.608 0 1.644.278 3.018.837 4.12.714 1.405 1.786 2.098 3.215 2.074 2.682-.02 4.022-2.1 4.022-6.2m16.64 7.408h-2.436v-9.714c0-1.066-.328-1.897-.983-2.496s-1.53-.886-2.62-.863c-1.157.02-2.258.4-3.303 1.108V23.06h-2.436V10.8c1.402-.998 2.693-1.65 3.87-1.954 1.1-.284 2.092-.425 2.938-.425.578 0 1.122.054 1.634.164.958.216 1.736.617 2.335 1.206a3.15 3.15 0 0 1 1.002 2.348v10.92z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .84)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "F",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.02.332c-1.253.006-2.45.1-3.504.292C8.413 1.16 7.85 2.282 7.85 4.35v2.732h7.333v.91H5.097c-2.13 0-3.997 1.252-4.58 3.634C.178 13 .002 14.112 0 15.243v.038c.002 1.105.17 2.23.516 3.63.52 2.122 1.766 3.634 3.897 3.634h2.52V19.27c0-2.366 2.094-4.453 4.58-4.453h7.324c2.04 0 3.666-1.64 3.666-3.643V4.35c0-1.942-1.676-3.402-3.666-3.726a23.33 23.33 0 0 0-3.707-.292h-.114M9.678 3.9c0-.756.616-1.37 1.376-1.37s1.376.614 1.376 1.37a1.37 1.37 0 0 1-1.376 1.362c-.76 0-1.376-.61-1.376-1.362",
    fill: "url(#B)",
    mask: "url(#F)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.843 8.507)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "G",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.578.326V3.51c0 2.468-2.14 4.545-4.58 4.545H3.672c-2.006 0-3.666 1.68-3.666 3.643v6.826c0 1.942 1.728 3.085 3.666 3.642 2.32.667 4.547.788 7.324 0 1.846-.522 3.666-1.574 3.666-3.642V15.8H7.34v-.9h10.99c2.13 0 2.925-1.453 3.666-3.634.766-2.245.733-4.405 0-7.285C21.47 1.886 20.464.326 18.33.326h-2.752zm-5.495 18.647a1.37 1.37 0 0 1 1.376-1.362c.76 0 1.376.61 1.376 1.362s-.616 1.37-1.376 1.37-1.376-.615-1.376-1.37z",
    fill: "url(#D)",
    mask: "url(#G)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.12 3.507)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "H",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.942 3.148h.365V.756L4.1 3.148h.406L5.33.764v2.384h.398V.217h-.527L4.3 2.728 3.53.217h-.59v2.93zm-1.818 0h.427V.53h1.012V.217H.112V.53h1.012v2.62z",
    fill: "#646464",
    mask: "url(#H)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/Python.771d2b4b160552b48c5165f49d00f19c.svg";
export { ForwardRef as ReactComponent };